import React, {useState} from 'react'
import {
    Button,
    Checkbox,
    Collapse,
    FormControlLabel,
    Icon,
    IconButton,
    Paper,
    Typography
} from '@material-ui/core'
import _ from 'lodash'
import { useIntl } from 'src/common/razzle-platform-translate'
import { useMobileDetector } from 'src/common/razzle-platform-components/hooks/mobile-detector'


function CategoryFilter(props) {

    const [openedCollapses, setOpenedCollapses] = useState([])
    const { formatMessage } = useIntl()
    const { isMobile } = useMobileDetector()
    const { values, clearFilter, save, categories } = props


    const getChildren = (category) => {
        // This funtion is used to all of the categories with their children recursevly
        let returnedChildren = []
        if (category.subCategories) {
            // We get the children for the given category
            const children = category.subCategories.map(item => item)
            // Then we loop on it's children
            children.forEach(item => {
                // We need to get the category from all the categories, because in the subCategories
                // we only have the id and name
                const currentCategory = props.categories.filter(elem => elem.id === item.id)[0]
                // Then we push our category to our array
                returnedChildren.push({
                    ...currentCategory,
                    // We apply our recursivity on the subCategories to get all of it's
                    // child categories and so on.
                    subCategories: getChildren(currentCategory)
                })
            })
        }
        return returnedChildren
    }

    const organizeCategories = (categories) => {
        const categoryMain = categories.filter(item => !item.parentCategory && item.subCategories && item.subCategories.length > 0)[0]
        if (categoryMain) {
            return getChildren(categoryMain)
        }
        return categories
    }

    const isCategoryChecked = (key, id) => {
        if(props.values[key] && props.values[key].indexOf(id) !== -1){
            return true
        }else{
            return false
        }
    }

    const isCollapseChecked = (key, category) => {
        // Check if every sub catgory of the parent category exist in the filters
        // and store them in an array
        const checked = category.subCategories.map(item => {
            if(props.values[key] && props.values[key].indexOf(item.id) !== -1){
                return true
            }else{
                return false
            }
        })

        // Check if all the items in the array are true
        return checked.every(item => item)
    }



    const handleClick = (index) => {

        const selectedIndex = openedCollapses.indexOf(index);
        let newSelected = [];

        if (selectedIndex === -1) {
          newSelected = newSelected.concat(openedCollapses, index);
        } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(openedCollapses.slice(1));
        } else if (selectedIndex === openedCollapses.length - 1) {
          newSelected = newSelected.concat(openedCollapses.slice(0, -1));
        } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(
            openedCollapses.slice(0, selectedIndex),
            openedCollapses.slice(selectedIndex + 1),
          );
        }
        setOpenedCollapses(newSelected)
    };

    const showCategoryFields = (categories) => {

        const { handleChange, checkCollapse } = props

        return (
            categories.map((category, index) => {
                if (category.subCategories && category.subCategories.length > 0) {
                    const isChecked = isCollapseChecked('category.id', category)
                    const isOpened = openedCollapses.indexOf(category.id) !== -1
                    return (
                        <div key={index}>
                            <div className="flex flex-row justify-between items-center">
                                <div className="flex">
                                    <FormControlLabel
                                        className="mb-0"
                                        control={<Checkbox
                                            name="category.id"
                                            value={category.id}
                                            onChange={(event) => checkCollapse(event, isChecked, category)}
                                            checked={isChecked}
                                        />}
                                        label={<Typography>{category.name}</Typography>}
                                    />
                                </div>
                                <div className="flex justify-end">
                                    <IconButton onClick={() => handleClick(category.id)}>
                                        <Icon>{isOpened ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}</Icon>
                                    </IconButton>
                                </div>
                            </div>
                            <Collapse className="pl-4" in={!isOpened}>
                                {category.subCategories.map((cat, index) => {
                                    const isChecked = isCategoryChecked('category.id', cat.id)
                                    if (cat.subCategories && cat.subCategories.length > 0) {
                                        return showCategoryFields([cat])
                                    }
                                    return (
                                        <div key={index}>
                                            <FormControlLabel
                                                classes={{
                                                    root: !(index & 1) ? 'bg-gray-200' : ''
                                                }}
                                                className="mb-0 w-full"
                                                control={<Checkbox
                                                    name="category.id"
                                                    value={cat.id}
                                                    onChange={(event) => handleChange(event, true, isChecked)}
                                                    checked={isChecked}
                                                />}
                                                label={<Typography>{cat.name}</Typography>}
                                            />
                                        </div>
                                    )
                                })}
                            </Collapse>
                        </div>
                    )
                } else {
                    const isChecked = isCategoryChecked('category.id', category.id)
                    return (
                        <FormControlLabel
                            className="mb-0"
                            key={index}
                            control={<Checkbox
                                name="category.id"
                                value={category.id}
                                onChange={(event) => handleChange(event, true, isChecked)}
                                checked={isChecked}
                            />}
                            label={<Typography>{category.name}</Typography>}
                        />
                    )
                }
            })
        )
    }


    const showClear = !_.isEmpty(values['category.id'])
    const organizedCategories = categories.length > 0 ? organizeCategories(categories) : []


    return (
        <Paper className="p-8 pb-2">
            <div className="flex flex-col">
                <div className="flex items-center mb-4">
                    <Typography variant="h6">{formatMessage({ id: 'Pick a category', defaultMessage: 'Pick a category' })}</Typography>
                </div>

                <div className="flex flex-col px-4">
                    {showCategoryFields(organizedCategories)}
                </div>

                {!isMobile && <div className="flex items-center justify-between mt-4">
                    <div className="flex items-center">
                        {showClear && <Button onClick={() => clearFilter('category.id')} variant="text" className="text-gray-600">
                            <Typography>{formatMessage({ id: 'Clear', defaultMessage: 'Clear' })}</Typography>
                        </Button>}
                    </div>
                    <div className="flex items-center justify-end">
                        <Button onClick={save} variant="text">
                            <Typography>{formatMessage({ id: 'Save', defaultMessage: 'Save' })}</Typography>
                        </Button>
                    </div>
                </div>}
            </div>
        </Paper>
    )
}

export default CategoryFilter
